import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

import moment from 'moment';

import { Message, List } from 'semantic-ui-react';
import {
  ModalTemplate,
  Button,
  Loading,
  ReduxFormHiddenInput,
  ReduxFormMaterialTextField,
  ReduxFormDatePicker,
  SendReserve
} from 'components';

import { examNameAsyncValidate } from 'libs/validation';
import * as common from 'libs/commonFunc';

import styles from '../../../style/modal.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

class ModalExamEdit extends Component {
  constructor(props) {
    super(props);

    const dateFormat = localStorage.getItem('language') === 'en' ? 'MM/DD/YYYY' : 'YYYY-MM-DD';
    this.state = {
      startDate: moment(common.timeFormatFromUTCEpoch(props.selectedExam.get('examStartEpoch'), 3), dateFormat),
      endDate: moment(common.timeFormatFromUTCEpoch(props.selectedExam.get('examEndEpoch'), 3), dateFormat)
    };
  }

  handleDatePickerOnChangeStart = (e, date) => {
    if (!!!date) {
      return false;
    }

    date
      .hour(0)
      .minute(0)
      .second(0);

    const dateObj = {
      startDate: date
    };
    if (date > this.state.endDate) {
      // 시작 날짜를 종료 날짜 이후로 선택한 경우
      // 종료 날짜를 초기화 해준다.
      dateObj.endDate = null;
    }

    this.setState(dateObj);
  };

  handleDatePickerOnChangeEnd = (e, date) => {
    if (!!!date) {
      return false;
    }

    date
      .hour(23)
      .minute(59)
      .second(59);

    this.setState({
      endDate: date
    });
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { visible, isClicked, onExamEdit, onToggleModal, selectedExam, formExamEdit } = this.props;
    const { startDate, endDate } = this.state;

    if (!selectedExam) {
      return null;
    }

    const disabledStart = selectedExam.get('examStartEpoch') < common.nowEpoch() ? true : false;
    const disabledEnd = selectedExam.get('examEndEpoch') < common.nowEpoch() ? true : false;

    return (
      <ModalTemplate
        closeOnEscape={false}
        closeOnDimmerClick={false}
        className={cx('modal-examEdit-area', 'common-content')}
        visible={visible}
        onToggleModal={onToggleModal}
        header={defineMessages(formatMessage({ id: 'ModalExamEdit_1', defaultMessage: '훈련 수정' }))}
        buttons={
          <div className={cx('inline-block')}>
            <Button
              buttonColor="#bbbbbb"
              onClick={() => {
                onToggleModal('');
              }}>
              {defineMessages(formatMessage({ id: 'ModalExamEdit_3', defaultMessage: '취 소' }))}
            </Button>
            <Button className={cx('brand-button')} disabled={isClicked} onClick={onExamEdit}>
              {defineMessages(formatMessage({ id: 'ModalExamEdit_2', defaultMessage: '수 정' }))}
            </Button>
          </div>
        }>
        <div className={cx('modal-content', 'summary-examEdit')}>
          <Loading active={isClicked} size="small" content="Waiting..." />
          <span className={cx('materialTextField-title')}>
            {defineMessages(formatMessage({ id: 'ModalExamEdit_4', defaultMessage: '훈련명' }))}
          </span>
          <div className={cx('examName-area')}>
            <ReduxFormHiddenInput name="examNo" />
            <ReduxFormMaterialTextField
              className={cx('input-area')}
              validate={['required', 'examName']}
              name="examName"
              checkType={101}
            />
          </div>
          <div className={cx('date-area')}>
            <div className={cx('date-input')}>
              <span className={cx('materialTextField-title')}>
                {defineMessages(formatMessage({ id: 'ModalExamEdit_5', defaultMessage: '시작일자' }))}
              </span>
              {!!disabledStart ? (
                <div>
                  <div className={cx('disabled-date')}>
                    <div className={cx('content')}>
                      {common.timeFormatFromUTCEpoch(selectedExam.get('examStartEpoch'), 3)}
                    </div>
                  </div>
                </div>
              ) : (
                <ReduxFormDatePicker
                  defaultValue={moment(startDate)}
                  className={cx('date-input')}
                  name="examStartDate"
                  locale={localStorage.getItem('language')}
                  todayButton="Today"
                  shouldCloseOnSelect //={false}
                  selectsStart
                  showYearDropdown
                  dropdownMode="select"
                  showMonthDropdown
                  dateFormat={localStorage.getItem('language') === 'en' ? 'MM/DD/YYYY' : 'YYYY-MM-DD'}
                  startDate={startDate}
                  minDate={moment()}
                  maxDate={moment('2037-11-30')}
                  endDate={endDate}
                  onChange={this.handleDatePickerOnChangeStart}
                  checkType={100}
                  validate={['dateRequired', 'dateFuture']}
                  noerror
                  error={false}
                />
              )}
            </div>
            <div className={cx('date-input')}>
              <span className={cx('materialTextField-title')}>
                {defineMessages(formatMessage({ id: 'ModalExamEdit_6', defaultMessage: '종료일자' }))}
              </span>
              {!!disabledEnd ? (
                <div className={cx('disabled-date')}>
                  <div className={cx('content')}>
                    {common.timeFormatFromUTCEpoch(selectedExam.get('examEndEpoch'), 3)}
                  </div>
                </div>
              ) : (
                <ReduxFormDatePicker
                  defaultValue={moment(endDate)}
                  className={cx('date-input')}
                  name="examEndDate"
                  locale={localStorage.getItem('language')}
                  todayButton="Today"
                  shouldCloseOnSelect //={false}
                  selectsEnd
                  showYearDropdown
                  dropdownMode="select"
                  showMonthDropdown
                  dateFormat={localStorage.getItem('language') === 'en' ? 'MM/DD/YYYY' : 'YYYY-MM-DD'}
                  startDate={moment(startDate).add(2, 'd')}
                  minDate={moment(startDate).add(2, 'd')}
                  maxDate={moment('2037-12-31')}
                  endDate={moment(endDate)}
                  onChange={this.handleDatePickerOnChangeEnd}
                  checkType={101}
                  // validate={['dateRequired', 'dateFuture', 'reduxFormDatePicker']}
                  validate={['dateRequired', 'dateFuture']}
                  // noerror
                  error={!(formExamEdit && formExamEdit.examEndDate)}
                />
              )}
            </div>
          </div>
          {/* 훈련 메일 나눔 발송 */}
          {selectedExam.get('sendReservePeriod') && (
            <SendReserve
              isEditData={selectedExam}
              examStartDate={startDate}
              examEndDate={endDate}
              sendReserveEnable={!!!disabledEnd && formExamEdit ? formExamEdit.sendReserveEnable : 0}
              sendReservePeriod={formExamEdit ? formExamEdit.sendReservePeriod : selectedExam.get('sendReservePeriod')}
              sendReserveHour={
                formExamEdit && formExamEdit.sendReserveHour
                  ? [formExamEdit.sendReserveHour[0], formExamEdit.sendReserveHour[1]]
                  : [selectedExam.get('sendReserveStartHour'), selectedExam.get('sendReserveEndHour')]
              }
              disabledEndStat={!!disabledEnd ? true : false}
            />
          )}
        </div>
      </ModalTemplate>
    );
  }
}

ModalExamEdit.propTypes = {
  visible: PropTypes.bool,
  onToggleModal: PropTypes.func
};

const mapStateToProps = (state, props) => {
  return {
    initialValues: {
      examNo: props.selectedExam.get('examNo'),
      examName: props.selectedExam.get('examName'),
      examStartDate: common.timeFormatFromUTCEpoch(props.selectedExam.get('examStartEpoch'), 3),
      examEndDate: common.timeFormatFromUTCEpoch(props.selectedExam.get('examEndEpoch'), 3),
      sendReserveEnable: !!props.selectedExam.get('sendReservePeriod') ? 1 : 0,
      sendReservePeriod: props.selectedExam.get('sendReservePeriod'),
      sendReserveStartHour: props.selectedExam.get('sendReserveStartHour'),
      sendReserveEndHour: props.selectedExam.get('sendReserveEndHour')
    }
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'formExamEdit',
    enableReinitialize: true,
    asyncValidate: examNameAsyncValidate,
    asyncBlurFields: ['examName'],
    // destroyOnUnmount: false,
    touchOnChange: true // validation 안내를 적절한 시점에 보이기 위해 반드시 필요함
  })(injectIntl(ModalExamEdit))
);



// WEBPACK FOOTER //
// ./src/script/components/modal/ModalExamEdit.js